import React from 'react'
import AuthProvider from './src/components/Context/AuthProvider'
import CartProvider from './src/components/Context/CartProvider'


// Consent
import ConsentProvider from "./src/components/Consent/consentprovider"

// eslint-disable-next-line import/prefer-default-export
const WrapWithProviderRoot = ({ element }) => (
	<ConsentProvider>
		<AuthProvider>
			<CartProvider>{element}</CartProvider>
		</AuthProvider>
	</ConsentProvider>
)

export default WrapWithProviderRoot
